import React, { useEffect, useState } from "react";
import CustomDataGrid from "../../../../../../components/common/CustomDataGrid";
import { insuranceColumns } from "../../../../../../constants/columns/financialColumns";
import { adminApi } from "../../../../../../services";
import { Link } from "react-router-dom";

export default function Insurance() {
  const [insuranceList, setInsuranceList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchInsurance = async () => {
    try {
      const res = await adminApi.getAllInsurance();
      setInsuranceList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch insurance");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInsurance();
  }, []);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-3">
        <h2>Insurance Policies</h2>
        <Link to="/admin-dashboard/insurance/create">
          <button className="btn btn-primary">+ Create Insurance</button>
        </Link>
      </div>

      <CustomDataGrid
        rows={insuranceList}
        columns={insuranceColumns}
        loading={loading}
        getRowId={(row) => row._id}
      />
    </div>
  );
}
